import { fetchChallengeScoreSummary } from '@actions/challenges';
import { RootState } from '@reducers/index';
import {
    getChallengeScoreSummary,
    getChallengesFetchError,
    getChallengesIsFetching,
} from '@selectors/challenges';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFetchChallengeScoreSummary = (id: number) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchChallengeScoreSummary(id));
    }, [dispatch, id]);

    const scoreSummary = useSelector((state: RootState) => getChallengeScoreSummary(state, id));
    const isFetching = useSelector(getChallengesIsFetching);
    const fetchError = useSelector(getChallengesFetchError);

    return { scoreSummary, isFetching, fetchError };
};

export default useFetchChallengeScoreSummary;
